import { render } from "./HelpDeskInstructorLibrary.vue?vue&type=template&id=0f095866&scoped=true"
import script from "./HelpDeskInstructorLibrary.vue?vue&type=script&lang=js"
export * from "./HelpDeskInstructorLibrary.vue?vue&type=script&lang=js"

import "./HelpDeskInstructorLibrary.vue?vue&type=style&index=0&id=0f095866&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f095866"]])

export default __exports__